import { getAuth } from "firebase/auth";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { addContent, createProperty, createRooms, getContents, getProperties, getRooms } from "../firebase/controller/property";
import { closeModal, openModal } from "../redux/modal/modalRedux";
import { uploadMultiple } from "../utils";
const PropertyContext = React.createContext();

export function useProperty() {
  return useContext(PropertyContext);
}

export function PropertyProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [properties, setProperties] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [mediaURLs, setMediaURLs] = useState([]);
  const [uploadImage, setUploadImage] = useState(null);
  const [done, setDone] = useState(false);
  const [values, setValues] = useState();
  const [contents, setContents] = useState([]);

  const createproperty = useCallback(
    async (status) => {
      if (uploadImage) {
        uploadMultiple(uploadImage, mediaURLs, setMediaURLs, setLoading, status, async () => {
          const res = await createProperty(values, mediaURLs);
          res && toast.success("Property added successfully.");
          setDone(true);
          setLoading(false);
        });
      }
    },
    [values, uploadImage, mediaURLs]
  );
  const uploadProperty = async (property) => {
    try {
      setLoading(true);
      const res = await createProperty(property);
      res && toast.success("Property added successfully.");
      setLoading(false);
      setDone(true);
    } catch (error) {
      toast.error("There is an error adding property, try again");
      setLoading(false);
      setDone(true);
      console.log(error.message);
    }
  };
  const getproperties = async () => {
    try {
      setLoading(true);
      const res = await getProperties();
      setProperties(res);
      setLoading(false);
    } catch (error) {
      const message = error.message;
      toast.error(message);
      setLoading(false);
    }
  };

  const getrooms = async (name) => {
    try {
      dispatch(openModal());
      const res = await getRooms(name);
      setContents([]);
      setRooms(res);
      dispatch(closeModal());
    } catch (error) {
      const message = error.message;
      toast.error(message);
      dispatch(closeModal());
    }
  };

  const getcontents = async (name, room) => {
    try {
      dispatch(openModal());
      const res = await getContents(name, room);
      setContents(res);
      dispatch(closeModal());
    } catch (error) {
      const message = error.message;
      toast.error(message);
      dispatch(closeModal());
    }
  };

  const addcontent = useCallback(
    async (status) => {
      if (uploadImage) {
        uploadMultiple(uploadImage, mediaURLs, setMediaURLs, setLoader, status, async () => {
          const res = await addContent(values, mediaURLs);
          res && toast.success("Content added successfully.");
          setLoader(false);
        });
      }
    },
    [uploadImage, mediaURLs, values]
  );

  const uploadContent = async (content) => {
    try {
      setLoader(true);
      const res = await addContent(content);
      res && toast.success("Content added successfully.");
      setLoader(false);
    } catch (error) {
      toast.error("There is an error adding content, try again");
      console.log(error.message);
      setLoader(false);
    }
  };

  const createrooms = async (data) => {
    try {
      setLoading(true);
      const res = await createRooms(data);
      res && toast.success("Rooms added successfully.");
      setLoading(false);
      setDone(true);
    } catch (error) {
      toast.error("There is an error adding content, try again");
      console.log(error.message);
      setLoading(false);
      setDone(true);
    }
  };

  useEffect(() => {
    (async function () {
      if (uploadImage && mediaURLs.length === Array.from(uploadImage).length) {
        await addcontent(true);
      }
    })();
  }, [addcontent, mediaURLs.length, uploadImage]);

  useEffect(() => {
    (async function () {
      if (uploadImage && mediaURLs.length === Array.from(uploadImage).length) {
        await createproperty(true);
      }
    })();
  }, [createproperty, mediaURLs.length, uploadImage]);

  useEffect(() => {
    const unsubscribe = getAuth().onAuthStateChanged((user) => {
      if (user) {
        getproperties();
      }
    });
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = {
    loading,
    setLoading,
    createproperty,
    addcontent,
    properties,
    getrooms,
    rooms,
    setUploadImage,
    loader,
    done,
    setValues,
    createrooms,
    getcontents,
    contents,
    uploadContent,
    uploadProperty,
  };

  return <PropertyContext.Provider value={value}>{children}</PropertyContext.Provider>;
}
